/*
* Project: LegalPlace assistant
* File: src/components/misc/warning.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';

class _LpWarning extends Component {
  constructor(props) {
    super(props);
    this.is_hidden = true;
  }

  componentDidMount() {
    let me;
    if (this.props.type === 'v') me = lpGetVariableById(this.props.id);
    else me = lpGetOptionById(this.props.id);
    // debugger;
    if (me) {
      this.is_hidden = !me.value;
      if (this.props.type === 'v') this.is_hidden = false;
      // if(this.props.id == 243)debugger;
      this.forceUpdate();
    }
  }

  componentWillUpdate(nextProps) {
    let me;
    if (this.props.type === 'v') me = lpGetVariableById(this.props.id);
    else me = lpGetOptionById(nextProps.id);
    if (me) {
      this.is_hidden = !me.value;
      if (this.props.type === 'v') this.is_hidden = false;
    }
  }

  render() {
    return (
      <div className="infobox" data-type="warning" style={{ display: this.is_hidden ? 'none' : 'block' }}>
        <p dangerouslySetInnerHTML={{ __html: this.props.text }} />
      </div>
    );
  }
}


const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({});
const LpWarning = connect(mapStateToProps, mapDispatchToProps)(_LpWarning);

export default LpWarning;



// WEBPACK FOOTER //
// ./src/components/misc/warning.js